import { render, staticRenderFns } from "./BuildingPage.vue?vue&type=template&id=d548ab86&scoped=true&"
import script from "./BuildingPage.vue?vue&type=script&lang=js&"
export * from "./BuildingPage.vue?vue&type=script&lang=js&"
import style0 from "./BuildingPage.vue?vue&type=style&index=0&id=d548ab86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d548ab86",
  null
  
)

export default component.exports